<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>Condomínios</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            v-if="showDownloadButton"
            dark
            small
            fab
            color="#696A6D"
            @click="downloadExcel()"
          >
            <v-icon>download</v-icon>
          </v-btn>
        </template>
        <span>Download documentos</span>
      </v-tooltip>

      <CondominiumFormDlg
        :showPrepository="showPrepository"
        :prepositories="prepositories"
        :addButton="condPermissions && condPermissions.edit"
        :dialog="frmCondominiumDialog"
        :openForm="() => openDialogForm()"
        :closeForm="() => closeDialogForm()"
        :getCondominiums="getCondominiums"
        :saveCondominium="(data) => saveCondominium(data)"
        :editFormData="formData"
        :reopenFormFilled="reopenFormFilled"
      />
    </v-toolbar>

    <SearchCondominiums :searchCondominiums="(cond) => getCondominiums(cond)" />

    <v-data-table
      :headers="headers"
      :items="tableData"
      rows-per-page-text="Linhas por página"
      no-data-text="Não há dados"
    >
      <template v-slot:items="props">
        <td class="text-xs-center">
          <v-icon color="success" v-if="props.item.active">check_circle</v-icon>
          <v-icon color="error" v-if="!props.item.active">block</v-icon>
        </td>
        <td class="text-xs-left">
          <b>{{ props.item.name_fantasy }}</b>
        </td>
        <td class="text-xs-left">
          {{ props.item.name_company }}
          <br />
          <small>
            <b>CNPJ:</b>
            {{ props.item.document | formatCnpjCpf }}
          </small>
        </td>
        <td class="text-xs-center layout">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                small
                class="mr-2"
                @click="showPrepository(props.item.representative_id)"
                >contact_mail</v-icon
              >
            </template>
            <span>Ver preposto</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                v-if="condPermissions && condPermissions.edit"
                small
                class="mr-2"
                @click="editItem(props.item)"
                >edit</v-icon
              >
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                v-if="condPermissions && condPermissions.view"
                small
                class="mr-2"
                @click="editItem(props.item, 'viewForm')"
                >remove_red_eye</v-icon
              >
            </template>
            <span>Visualizar</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                small
                class="mr-2"
                @click="confirmtoggleStatusItem(props.item)"
                v-if="
                  !props.item.active && condPermissions && condPermissions.edit
                "
                >check</v-icon
              >
            </template>
            <span>Ativar</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                small
                class="mr-2"
                @click="confirmtoggleStatusItem(props.item)"
                v-if="
                  props.item.active && condPermissions && condPermissions.edit
                "
                >block</v-icon
              >
            </template>
            <span>Desativar</span>
          </v-tooltip>
          <!-- <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                v-if="condPermissions && condPermissions.remove"
                small
                @click="confirmDelCondominium(props.item)"
                >delete</v-icon
              >
            </template>
            <span>Excluir</span>
          </v-tooltip> -->
        </td>
      </template>
    </v-data-table>

    <PrepositoryDetailDlg
      :resetDialog="resetDialog"
      :dialogShow="dialogShowPrepository"
      :prepositoryData="prepositoryData"
    />
  </div>
</template>

<script>
import * as moment from 'moment'
import axios from 'axios'
import {
  condominiums as condominiumService,
  deleteCondominium as deleteCondominiumService,
  toggleStatus as toggleService,
  addCondominium as addCondominiumService,
  updateCondominium as updateCondominiumService
} from '@/services/condominiuns'
import { representatives as representativeService } from '@/services/providers/representative'
import SearchCondominiums from '@/components/condominiums/SearchCondominiums.vue'
import CondominiumFormDlg from '@/components/condominiums/CondominiumFormDlg.vue'
import PrepositoryDetailDlg from '@/components/condominiums/PrepositoryDetailDlg'

const resquestToSaveCondominium = {
  patch: updateCondominiumService,
  post: addCondominiumService
}

export default {
  name: 'Condominiums',

  components: {
    PrepositoryDetailDlg,
    CondominiumFormDlg,
    SearchCondominiums
  },

  data () {
    return {
      dialogShowPrepository: false,
      prepositoryData: {},
      prepositories: [],
      headers: [
        {
          text: 'Status',
          align: 'center',
          sortable: true,
          value: 'active'
        },
        { text: 'Condomínio', sortable: true, value: 'name_fantasy' },
        { text: 'Nome/Razão social', sortable: true, value: 'name_company' },
        { text: 'Ações', value: '', sortable: false, align: 'left' }
      ],
      tableData: [],
      frmCondominiumDialog: false,
      formData: null,
      lastSearch: {}
    }
  },

  computed: {
    condPermissions () {
      return this.$store.state.permissions.permissions.condominiums
    },

    showDownloadButton () {
      try {
        return this.tableData.length > 0 && this.$store.state.permissions.permissions.Adm.adm
      } catch (error) {
        console.log('User is not an adm')
      }

      return false
    }
  },

  mounted () {
    this.getPrepository()

    this.getCondominiums()
  },

  methods: {
    async reopenFormFilled (id) {
      this.closeDialogForm()

      await this.getCondominiums()

      this.tableData.every(condominium => {
        if (condominium.id == id) {
          this.formData = Object.assign({}, condominium)
          this.frmCondominiumDialog = true

          return false
        }

        return true
      })
    },

    resetDialog () {
      this.dialogShowPrepository = false
    },

    downloadExcel () {
      let obj = {
        url: 'api/export',
        query: this.lastSearch,
        method: 'get',
        filename: 'condominius.zip'
      }

      this.$store.dispatch('request/download', obj).then(response => {
        console.log('DOWNLOAD SUCCESS')
      })
    },

    showPrepository (id) {
      var ind = this.prepositories.findIndex((prep) => prep.id === id)
      this.prepositoryData = { ...this.prepositories[ind] }
      this.dialogShowPrepository = true
    },

    async getPrepository () {
      this.prepositories = await representativeService()
    },

    confirmtoggleStatusItem (condominium) {
      let action = condominium.active ? 'desativar' : 'ativar'

      let obj = {
        message: `Você deseja ${action} o condomínio "${condominium.name_fantasy}"?`,
        title: `${condominium.active ? 'Desativar condomínio' : 'Ativar condomínio'}`,
        callback: (_) => {
          this.toggleStatusItem(condominium)
        },
        type: 'warning',
        btConfirm: { name: 'Sim', show: true },
        btCancel: { name: 'Não', show: true }
      }

      this.$store.commit('confirmMessage/showConfirmMessage', obj)
    },

    async toggleStatusItem (condominium) {
      await toggleService(condominium.id)

      let opts = {
        message: `Status modificado com sucesso`,
        type: 'success'
      }

      this.$store.commit('showAlert', opts)

      this.getCondominiums(this.lastSearch)
    },

    confirmDelCondominium (condominium) {
      let obj = {
        message: `Você deseja excluir o condomínio "${condominium.name_fantasy}"?`,
        title: 'Excluir condomínio',
        callback: (_) => {
          this.delCondominium(condominium)
        },
        type: 'warning',
        btConfirm: { name: 'Sim', show: true },
        btCancel: { name: 'Não', show: true }
      }

      this.$store.commit('confirmMessage/showConfirmMessage', obj)
    },

    async delCondominium (condominium) {
      await deleteCondominiumService(condominium.id)

      let opts = {
        message: `Condomínio removido com sucesso`,
        type: 'success'
      }

      this.$store.commit('showAlert', opts)

      this.getCondominiums(this.lastSearch)
    },

    async getCondominiums (searchParams = {
      name: '',
      flag_active: 'false'
    }) {
      this.$store.commit('showLoader', {
        circle: true
      })

      this.lastSearch = searchParams

      const response = await condominiumService(searchParams)

      let condominiumTableData = response

      if (condominiumTableData.length) {
        for (let i = 0; i < condominiumTableData.length; i++) {
          condominiumTableData[i].building.map((b) => {
            b.disab = true
            return b
          })
        }
      }

      this.tableData = condominiumTableData

      this.$store.commit('hideLoader')
    },

    editItem (item, view) {
      view === 'viewForm' ? (item.view = true) : (item.view = false)
      this.formData = Object.assign({}, item)
      this.frmCondominiumDialog = true
    },

    openDialogForm () {
      this.formData = null
      this.frmCondominiumDialog = true
    },

    closeDialogForm () {
      this.frmCondominiumDialog = false
    },

    sendFile (file, id, callback) {
      let USER_TOKEN = localStorage.getItem('token')
      let AuthStr = 'Bearer '.concat(USER_TOKEN)
      let formData = new FormData()
      // formData.append(prop, data[prop]);
      formData.append('id', id)
      formData.append('avatar', file)

      axios.defaults.baseURL =
        process.env.NODE_ENV === 'production'
          ? process.env.VUE_APP_API_URL
          : /* 'http://187.103.137.78''http://192.168.20.41:9000''http://172.16.224.54:9000' */ process
            .env.VUE_APP_API_URL_DEV
      axios
        .post('/api/condominium/upload_photo', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: AuthStr
          }
        })
        .then((resp) => {
          this.$store.commit('hideLoader')
          if (callback) {
            callback()
          }
        })
        .catch((error) => {
          let paramModal = {}
          paramModal.message = error.response
            ? error.response.data.errors
              ? Object.values(error.response.data.errors).join('<br>')
              : error.response.data.message
            : 'Contate o administrador do sistema'
          paramModal.title = 'Ocorreu erro'
          paramModal.type = 'error'
          paramModal.callback = null
          paramModal.btConfirm = {
            name: 'Ok',
            show: true
          }
          paramModal.btCancel = {
            show: false
          }
          this.$store.commit('hideLoader')
          this.$store.commit('confirmMessage/showConfirmMessage', paramModal)
        })
    },

    async saveCondominium (condominium) {
      this.$store.commit('showLoader', {
        circle: true
      })

      const requestMethod = condominium.id ? 'patch' : 'post'

      condominium.syndication_mandate_list = condominium.syndicationMandateList.map(
        (item) => {
          if (item.date_init.split('-').length < 3) {
            let lastDay = moment(item.date_end).daysInMonth()
            item.date_end = `${item.date_end}-${lastDay}`
            item.date_init = `${item.date_init}-01`
          }
          return item
        }
      )

      const response = await resquestToSaveCondominium[requestMethod](condominium)

      if (!condominium.avatar.startsWith('http')) {
        this.sendFile(condominium.imageFile, response.id, (_) =>
          this.responseSave(condominium.id)
        )
      } else {
        this.$store.commit('hideLoader')
        this.responseSave(condominium.id)
      }

      this.$store.commit('hideLoader')
    },

    responseSave (edit) {
      let opts = {
        message: `Condomínio ${edit ? 'alterado' : 'criado'} com sucesso`,
        type: 'success'
      }
      this.$store.commit('showAlert', opts)
      this.frmCondominiumDialog = false
      this.getCondominiums(this.lastSearch)
    }
  },

  filters: {
    formatCnpjCpf (value) {
      if (value.length > 11) {
        value = value.replace(
          /^([0-9]{2})([0-9]{3})([0-9]{3})([0-9]{4})([0-9]{2})$/,
          '$1.$2.$3/$4-$5'
        )
      } else {
        value = value.replace(
          /^([0-9]{3})([0-9]{3})([0-9]{3})([0-9]{2})$/,
          '$1.$2.$3-$4'
        )
      }
      return value
    }
  }
}
</script>

<style>
</style>
